import React from 'react';
import moment from 'moment';
import Form from 'antd/lib/form';
import DatePicker from 'antd/lib/date-picker';
import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/date-picker/style/index.css';
import 'antd/lib/tooltip/style/index.css';
var RangePicker = DatePicker.RangePicker;
var InputDate = function (props) { return (React.createElement(Form.Item, { label: React.createElement("span", null,
        "Round date & time ",
        React.createElement(Tooltip, { title: 'To change timezone, go to "Event"' },
            "(UTC ",
            props.timezoneDisplay,
            ")")), colon: false }, props.form.getFieldDecorator("rounds[" + props.index + "][date]", {
    initialValue: [moment(props.initialValueStart).utcOffset(props.utcOffset), moment(props.initialValueEnd).utcOffset(props.utcOffset)],
    rules: [{
            required: true,
            message: 'Please let us know the dates for your event!',
        }],
})(React.createElement(RangePicker, { size: 'large', disabled: props.isDisabled, showTime: true, format: 'DD MMM YYYY, HH:mm', style: { display: 'block', width: '100%' } })))); };
export default InputDate;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormCategoryPage/FormRound/InputDate.tsx
// module id = 1180
// module chunks = 0